import React, { useEffect, useState } from "react";
import { Button, Card, ListGroup, Pagination } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Loader from "../../components/Loader";
import Message from "../../components/Message";
import { allPastEvents } from "../../actions/eventActions";
import Paginate3 from "./Paginate3";

const HomePastEvents = () => {
  const dispatch = useDispatch();
  const [pageNumber, setPageNumber] = useState(0);

  const eventPastAll = useSelector((state) => state.eventPastAll);
  const {
    loading: eventsLoading,
    error: eventsError,
    pastEvents,
    totalPastPages,
    currentPastPage,
  } = eventPastAll;

  // Same summary-not-browser reasoning as the upcoming list above it.
  const VISIBLE_COUNT = 5;
  const [showAll, setShowAll] = useState(false);
  const events = pastEvents || [];
  const shownEvents = showAll ? events : events.slice(0, VISIBLE_COUNT);

  const checkChapter = window.location.host;
  // const subDomain = window.location.host.split('.')[0];

  useEffect(() => {
    dispatch(allPastEvents(checkChapter, "", pageNumber)); // done
  }, [dispatch, checkChapter, pageNumber]);

  const changePageNumber = (changePageNumber) => {
    setPageNumber(changePageNumber);
  };

  return (
    <Card className="mb-2">
      <Card.Header className="text-info text-center" as="h4">
        Past Events
      </Card.Header>
      <>
        {eventsLoading ? (
          <Loader />
        ) : eventsError ? (
          <Message variant="danger">{eventsError}</Message>
        ) : (
          <ListGroup variant="flush">
            {shownEvents.map((event, index) => (
              <ListGroup.Item key={index} className="list-group-item-action">
                <Link to={`/event/${event.eventId}`}>
                  <span className="text-info d-flex justify-content-between align-items-center">
                    {event.eventName}
                    {/* {event.eventStatus ? (
                      <>
                        <span className="badge badge-info badge-pill blink_me">
                          Upcoming
                        </span>
                      </>
                    ) : null} */}
                  </span>
                </Link>
              </ListGroup.Item>
            ))}
          </ListGroup>
        )}

        {events.length > VISIBLE_COUNT && (
          <div className="text-center pb-2">
            <Button
              variant="link"
              size="sm"
              className="text-info p-0"
              onClick={() => setShowAll(!showAll)}
            >
              {showAll ? "Show less" : "Show more"}
            </Button>
          </div>
        )}

        <div className="align-middle">
          {totalPastPages > 1 && (
            <Pagination size="sm" className="justify-content-center my-1">
              <Paginate3
                totalPages={totalPastPages}
                currentPage={currentPastPage}
                changePageNumber={changePageNumber}
              />
            </Pagination>
          )}
        </div>
      </>
    </Card>
  );
};

export default HomePastEvents;
